import React from 'react';
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
const PageButton = ({ label, icon, disabled, onClick }) => {
    return (React.createElement("button", { type: "button", title: label, "aria-label": label, disabled: disabled, onClick: onClick, className: "inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40" },
        React.createElement("span", { className: "material-symbols-outlined text-xl", "aria-hidden": true }, icon)));
};
const BlogArticleListPaging = ({ page, length, recordsFiltered, onPageChange, onLengthChange }) => {
    const pageCount = Math.max(1, Math.ceil(recordsFiltered / length));
    const from = recordsFiltered === 0 ? 0 : (page - 1) * length + 1;
    const to = Math.min(page * length, recordsFiltered);
    return (React.createElement("div", { className: "flex flex-wrap items-center justify-between gap-x-6 gap-y-2 py-3 text-sm text-gray-600" },
        React.createElement("p", { "aria-live": "polite" },
            "Showing ",
            from,
            " to ",
            to,
            " of ",
            recordsFiltered),
        React.createElement("div", { className: "flex flex-wrap items-center gap-x-6 gap-y-2" },
            onLengthChange && (React.createElement("label", { htmlFor: "blog-articles-rows-per-page", className: "flex items-center gap-2" },
                "Rows per page",
                React.createElement("select", { id: "blog-articles-rows-per-page", value: length, onChange: (event) => {
                        onLengthChange(Number(event.target.value));
                    }, className: "h-8 rounded-md border border-gray-300 bg-white px-2 text-gray-800" }, ROWS_PER_PAGE_OPTIONS.map((option) => {
                    return (React.createElement("option", { key: option, value: option }, option));
                })))),
            React.createElement("div", { className: "flex items-center gap-2" },
                React.createElement(PageButton, { label: "Previous page", icon: "chevron_left", disabled: page <= 1, onClick: () => {
                        onPageChange(page - 1);
                    } }),
                React.createElement("span", { className: "whitespace-nowrap" },
                    "Page ",
                    page,
                    " of ",
                    pageCount),
                React.createElement(PageButton, { label: "Next page", icon: "chevron_right", disabled: page >= pageCount, onClick: () => {
                        onPageChange(page + 1);
                    } })))));
};
export default BlogArticleListPaging;
